import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { graphql } from 'src/generated';
import { SendCommentTableRowInput } from 'src/generated/graphql';

const sendActivitiesMessageMutation = graphql(`
  mutation SendActivitiesMessage($input: SendCommentTableRowInput!) {
    sendCommentTableRow(input: $input) {
      ...tableRowComment
    }
  }
`);

export const useSendActivitiesMessageMutation = () => {
  const [mutate, { loading, error }] = useMutation(
    sendActivitiesMessageMutation,
  );

  const activitiesSendMessage = useCallback(
    async (input: SendCommentTableRowInput) =>
      mutate({
        variables: {
          input,
        },
      }),
    [mutate],
  );

  return {
    activitiesSendMessage,
    isSendingMessage: loading,
    isSendingMessageError: error,
  };
};
